import { createAction } from 'redux-actions';
import { createRequestAction } from 'redux-flight-control';

import {
  getServiceProviders,
} from './api';

import {
  ADD_OR_UPDATE_SERVICE_PROVIDERS,
  CLEAR_SERVICE_PROVIDERS,
  LOAD_SERVICE_PROVIDERS,
} from '../constants';

// redux-actions allows us to create very versatile action creators in a single line.
export const addOrUpdateServiceProviders = createAction(ADD_OR_UPDATE_SERVICE_PROVIDERS);

export const loadServiceProviders = createRequestAction(
  LOAD_SERVICE_PROVIDERS,
  getServiceProviders,
);

export const clearServiceProviders = createAction(CLEAR_SERVICE_PROVIDERS);



// WEBPACK FOOTER //
// ./redux/serviceProviders/actions.js